<template>
	<gc-dialog
		:show.sync="dialogVisible"
		title="地图拾取坐标"
		width="980px"
		:close-on-press-escape="false"
		:show-close="false"
		@ok="handleConfirm"
		@cancel="handleCancel"
	>
		<div class="map-container">
			<div class="map-toolbar">
				<div class="map-info">
					<div class="info-item">
						<span class="label">经度：</span>
						<el-input
							class="value"
							v-model="lnglat.lng"
							placeholder="请输入经度"
							@change="handleLngChange"
						/>
					</div>
					<div class="info-item">
						<span class="label">纬度：</span>
						<el-input
							class="value"
							v-model="lnglat.lat"
							placeholder="请输入纬度"
							@change="handleLatChange"
						/>
					</div>
				</div>
				<el-autocomplete
					v-model="address"
					class="inline-input"
					placeholder="请输入地址进行搜索"
					value-key="name"
					:fetch-suggestions="querySearch"
					:trigger-on-focus="false"
					@select="handleSelect"
				>
					<i class="el-icon-search el-input__icon" slot="suffix"></i>
				</el-autocomplete>
			</div>
			<div class="map-wrapper">
				<div id="mapPicker" class="map-box"></div>
			</div>
		</div>
	</gc-dialog>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { AMapKey } from '@/config'

export default {
	name: 'GcMapPicker',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		defaultLng: {
			type: [String, Number],
			default: '',
		},
		defaultLat: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			dialogVisible: false,
			AMap: null,
			map: null,
			marker: null,
			mapLoaded: false,
			lnglat: { lng: null, lat: null },
			autoComplete: null,
			placeSearch: null,
			geocoder: null,
			address: null,
		}
	},
	watch: {
		visible: {
			handler(val) {
				this.dialogVisible = val
				if (val) {
					this.$nextTick(() => {
						this.initMap()
					})
				}
			},
			immediate: true,
		},
		dialogVisible(val) {
			this.$emit('update:visible', val)
		},
		lnglat(val) {
			this.$emit('current-position', val)
		},
	},
	methods: {
		initMap() {
			if (this.map) return

			AMapLoader.load({
				key: AMapKey,
				version: '2.0',
				plugins: ['AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
			})
				.then(AMap => {
					this.AMap = AMap
					this.map = new AMap.Map('mapPicker', {
						zoom: 15,
						resizeEnable: true,
					})

					this.map.on('complete', () => {
						this.mapLoaded = true
						if (this.defaultLng && this.defaultLat) {
							this.setMarker(Number(this.defaultLng), Number(this.defaultLat))
							this.lnglat.lng = Number(this.defaultLng).toFixed(6)
							this.lnglat.lat = Number(this.defaultLat).toFixed(6)
						} else {
							this.locateToCurrentPosition()
						}
					})

					this.map.on('click', e => {
						const lng = e.lnglat.getLng()
						const lat = e.lnglat.getLat()
						this.setMarker(lng, lat)
					})

					this.autoComplete = new AMap.AutoComplete()
					this.placeSearch = new AMap.PlaceSearch({ map: this.map })
					this.geocoder = new AMap.Geocoder()
				})
				.catch(e => {
					console.error('地图加载失败:', e)
				})
		},
		locateToCurrentPosition() {
			const geolocation = new this.AMap.Geolocation({
				enableHighAccuracy: true,
				timeout: 10000,
				zoomToAccuracy: true,
			})
			geolocation.getCurrentPosition((status, result) => {
				console.log('定位结果:', status, result)
				if (status === 'complete') {
					this.map.setCenter([result.position.lng, result.position.lat])
				}
			})
		},
		setMarker(lng, lat, address) {
			if (this.marker) {
				this.map.remove(this.marker)
			}
			this.marker = new this.AMap.Marker({
				position: [lng, lat],
				animation: 'AMAP_ANIMATION_DROP',
			})
			this.map.add(this.marker)
			this.map.setCenter([lng, lat])
			this.lnglat.lng = lng.toFixed(6)
			this.lnglat.lat = lat.toFixed(6)
			if (address) {
				this.address = address
				return
			}
			this.resolveAddress(lng, lat)
		},
		resolveAddress(lng, lat) {
			if (!this.geocoder) {
				return
			}
			this.geocoder.getAddress([lng, lat], (status, result) => {
				if (status === 'complete' && result.regeocode) {
					this.address = result.regeocode.formattedAddress || ''
				}
			})
		},
		querySearch(queryString, cb) {
			this.autoComplete.search(queryString, (status, result) => {
				let resultList = []
				if (status === 'complete') {
					resultList = result.tips
				}
				cb(resultList)
			})
		},
		handleSelect(item) {
			this.placeSearch.setCity(item.adcode)
			this.placeSearch.search(item.name, (status, result) => {
				let list = result.poiList.pois || []
				if (list.length) {
					const lng = list[0].location.lng
					const lat = list[0].location.lat
					this.setMarker(lng, lat, list[0].address || list[0].name || item.name)
				}
			})
		},
		handleLngChange(value) {
			const lng = Number(value)
			const lat = this.lnglat.lat ? Number(this.lnglat.lat) : null
			if (lng && lat) {
				this.setMarker(lng, lat)
			}
		},
		handleLatChange(value) {
			const lng = this.lnglat.lng ? Number(this.lnglat.lng) : null
			const lat = Number(value)
			if (lng && lat) {
				this.setMarker(lng, lat)
			}
		},
		handleCancel() {
			this.dialogVisible = false
		},
		handleConfirm() {
			if (this.lnglat.lng && this.lnglat.lat) {
				this.$emit('confirm', {
					longitude: this.lnglat.lng,
					latitude: this.lnglat.lat,
					address: this.address || '',
				})
			} else {
				this.$message.warning('请先在地图上选择位置')
				return
			}
			this.dialogVisible = false
		},
	},
}
</script>

<style lang="scss" scoped>
.map-container {
	position: relative;
}

.map-toolbar {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 12px;
}

.map-info {
	display: flex;
	align-items: center;
	gap: 8px;
	flex: none;
	width: 50%;
}

.info-item {
	display: flex;
	align-items: center;
	flex: 1;

	.label {
		color: #606266;
		font-size: 13px;
		min-width: 40px;
		white-space: nowrap;
	}

	.value {
		flex: 1;
	}
}

.inline-input {
	flex: none;
	width: 50%;
}

.map-box {
	width: 100%;
	height: 450px;
	border-radius: 4px;
	overflow: hidden;
}
</style>
